import { render, staticRenderFns } from "./WidgetListItem.vue?vue&type=template&id=1ff718d5&scoped=true&"
import script from "./WidgetListItem.vue?vue&type=script&lang=js&"
export * from "./WidgetListItem.vue?vue&type=script&lang=js&"
import style0 from "./WidgetListItem.vue?vue&type=style&index=0&id=1ff718d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff718d5",
  null
  
)

export default component.exports